import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const mappingCabang = {
  namespaced: true,

  state() {
    return {
      allMappings: [],
      totalMappings: 0,
      loading: false,
      loadingActiveMapping: false,
      mappingCache: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      allActiveMapping: [],
      requestActiveMapping: null,
      totalPage: 0,
      detail: null,
      available: [],
      assigned: [],
      cancelAvailable: null,
      cancelAssigned: null,
    };
  },

  mutations: {
    setMappings(state, { payload }) {
      state.allMappings = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMappings(state) {
      state.allMappings = [];
      state.totalMappings = 0;
    },

    setDetailData(state, payload) {
      state.detail = payload;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMappings(state, { payload }) {
      state.totalMappings = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setLoadingActiveMapping(state, loadingActiveMapping) {
      state.loadingActiveMapping = loadingActiveMapping;
    },

    removeMapping(state, { mapping }) {
      state.totalMappings -= 1;
      state.allMappings = state.allMappings.filter(
        (value) => value.mapping != mapping
      );
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    pushMapping(state, { payload }) {
      state.allMappings.push(payload);
      state.totalMappings += 1;
    },

    editMapping(state, { payload, index }) {
      Object.assign(state.allMappings[index], payload);
    },

    setActiveMappings(state, { payload }) {
      state.allActiveMapping = payload.data;
    },

    setAvailable(state, payload) {
      state.available = payload.data.list;
    },

    setAssigned(state, payload) {
      state.assigned = payload.data.list;
    },

    clearAvailable(state) {
      state.available = [];
    },

    clearAssigned(state) {
      state.assigned = [];
    },

    setCancelationAvailable(state, payload) {
      state.cancelAvailable = payload;
    },

    setCancelationAssigned(state, payload) {
      state.cancelAssigned = payload;
    },
  },

  actions: {
    async fetchMappings(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearMappings');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'id'} ${sort}`;
      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/maaping/cabang/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalMappings', {
          payload: responseData,
        });
        ctx.commit('setMappings', { payload: responseData });
      }
    },

    async fetchAvailable(ctx, { date, role, kodeCabang, kodePos, search }) {
      if (ctx.state.cancelAvailable) ctx.state.cancelAvailable.cancel();
      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationAvailable', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });
      ctx.commit('setLoading', true);
      ctx.commit('clearAvailable');

      const controller = (ctrl) => ctrl && 'maaping/cabang/maaping-available';

      const data = JSON.stringify({
        role_type: role,
        kode_cabang: kodeCabang,
        kodepos: kodePos,
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/${controller(role)}`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setAvailable', responseData);
      }
    },

    async fetchAssigned(ctx, { date, role, kodeCabang, kodePos, search }) {
      if (ctx.state.cancelAssigned) ctx.state.cancelAssigned.cancel();
      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationAssigned', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });
      ctx.commit('setLoading', true);
      ctx.commit('clearAssigned');

      const controller = (ctrl) => ctrl && 'maaping/cabang/maaping-assigned';

      const data = JSON.stringify({
        role_type: role,
        kode_cabang: kodeCabang,
        kodepos: kodePos,
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/${controller(role)}`;
      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setAssigned', responseData);
      }
    },

    async assign(ctx, { date, role, id, kode_cabang, kodePos }) {
      ctx.commit('setLoading', true);

      const controller = (ctrl) => ctrl && 'maaping/cabang/assign';

      const data = JSON.stringify({
        role_type: role,
        id,
        kode_cabang,
        kodepos: kodePos,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/${controller(role)}`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code == 200) {
        resVal = true;
      }
      return resVal;
    },

    async revoke(ctx, { date, role, id }) {
      ctx.commit('setLoading', true);

      const controller = (ctrl) => ctrl && 'maaping/cabang/unassign';

      const data = JSON.stringify({
        role_type: role,
        id,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/${controller(role)}`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code == 200) {
        resVal = true;
      }
      return resVal;
    },
  },
};
export default mappingCabang;
